// polyfill for browsers not supporting submitter event
!function () {
    let lastBtn = null;
    document.addEventListener('click', function (e) {
        if (!e.target.closest) {
            return;
        }
        lastBtn = e.target.closest('button, input[type=submit]');
    }, true);
    document.addEventListener('submit', function (e) {
        if ('submitter' in e) {
            return;
        }
        const canditates = [document.activeElement, lastBtn];
        for (var i = 0; i < canditates.length; i++) {
            var candidate = canditates[i];
            if (!candidate || !candidate.form || !candidate.matches('button, input[type=button], input[type=submit], input[type=image]')) {
                continue;
            }
            e.submitter = candidate;
            return;
        }
        e.submitter = e.target.querySelector('button, input[type=button], input[type=submit], input[type=image]');
    }, true);
}();